import React, { useContext, useEffect, useState } from 'react'
import { GlobalContext, TenantSettingsContext } from '../../../../App'
import API from '../../../../services/API'
import {
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material'
import { SiteModeContext } from '../../../../components/mainFrame/MainFrame'
import { defaultEventStatuses } from '../../../events/SingleEvent/StatusChip'
import EventStatusManager from './Statuses'

const EventPlanning = () => {
  const [eventPlanningSettings, setEventPlanningSettings] = useState({})
  const [eventStatuses, setEventStatuses] = useState(defaultEventStatuses)
  const { setToast } = useContext(GlobalContext)
  const tenantSettingsContext = useContext(TenantSettingsContext)
  const { setOrgConfig } = tenantSettingsContext
  const settings = tenantSettingsContext.orgConfig?.orgSettings
  const { mainFrameContainerRef } = useContext(SiteModeContext)

  useEffect(() => {
    const savedStatuses = settings?.eventPlanningSettings?.statuses

    setEventStatuses(
      savedStatuses &&
        typeof savedStatuses === 'object' &&
        !Array.isArray(savedStatuses) &&
        Object.keys(savedStatuses).length > 0
        ? savedStatuses
        : defaultEventStatuses,
    )

    setEventPlanningSettings(settings?.eventPlanningSettings || {})
  }, [settings])

  useEffect(() => {
    if (mainFrameContainerRef.current) {
      mainFrameContainerRef.current.scrollTo({ top: 0, behaviour: 'smooth' })
    }
  }, [])

  const handleSaveChanges = (e) => {
    e.preventDefault()

    API.put('/site-config', {
      eventPlanningSettings: {
        ...eventPlanningSettings,
        statuses: eventStatuses,
      },
    }).then((res) => {
      if (res.status === 200) {
        setToast(true)
        setOrgConfig((prev) => ({
          ...prev,
          orgConfig: {
            ...prev.orgConfig,
            ...res.data,
          },
        }))
      }
    })
  }

  return (
    <Stack gap={2} component="form" onSubmit={handleSaveChanges}>
      <Typography variant="title2">Event Planning Configuration</Typography>

      <EventStatusManager
        eventStatuses={eventStatuses}
        setEventStatuses={setEventStatuses}
      />

      <Typography variant="title3">Event Planning Screen</Typography>

      <FormControlLabel
        label="Show SMS History on Event Page"
        control={
          <Checkbox
            checked={eventPlanningSettings?.showSMSonEventPage ?? false}
            onChange={(e) =>
              setEventPlanningSettings((prev) => ({
                ...prev,
                showSMSonEventPage: e.target.checked,
              }))
            }
          />
        }
      />

      <Button type="submit" variant="contained">
        Save Changes
      </Button>
    </Stack>
  )
}

export default EventPlanning
